var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Padlock-Square-1--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Padlock Square 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "padlock-square-1--combination-combo-lock-locked-padlock-secure-security-shield-keyhole"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11 5.5H3c-0.55228 0 -1 0.44772 -1 1v6c0 0.5523 0.44772 1 1 1h8c0.5523 0 1 -0.4477 1 -1v-6c0 -0.55228 -0.4477 -1 -1 -1Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 5.5V4c0 -0.92826 -0.3687 -1.8185 -1.02513 -2.47487C8.8185 0.868749 7.92826 0.5 7 0.5c-0.92826 0 -1.8185 0.368749 -2.47487 1.02513C3.86875 2.1815 3.5 3.07174 3.5 4v1.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 10c0.27614 0 0.5 -0.22386 0.5 -0.5S7.27614 9 7 9s-0.5 0.22386 -0.5 0.5 0.22386 0.5 0.5 0.5Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockIcon);
export default __webpack_public_path__ + "static/media/padlock-icon.b82ad350be0e2157e353f93c9ea2a536.svg";
export { ForwardRef as ReactComponent };